<template>
  <div class="is-fullheight is-flex items-center justify-center section">
    <div class="columns is-centered is-100vw">
      <div class="column is-4">
        <div class="mb-6">
          <b-image src="/images/logo.png" />
        </div>

        <div class="box">
          <b-field label="New Password"
                   custom-class="is-large">
            <b-input v-model="pass"
                     type="password"
                     password-reveal
                     icon="lock"
                     size="is-large" />
          </b-field>

          <b-field :type="passConfirmFieldType"
                   label="Confirm Password"
                   :message="passConfirmMessage"
                   custom-class="is-large">
            <b-input v-model="passConfirm"
                     type="password"
                     password-reveal
                     icon="lock"
                     size="is-large"
                     :disabled="!pass" />
          </b-field>

          <div class="buttons is-centered">
            <b-button :disabled="(pass !== passConfirm) || !pass || !passConfirm"
                      size="is-large" @click="updatePass">
              Save
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {updateForgottenPassword} from '@/utils/api';

export default {
  data() {
    return {
      pass: '',
      passConfirm: '',
      code: '',
      loading: false,
    }
  },
  mounted() {
    this.code = this.$route.query._s;
  },
  methods: {
    updatePass: function () {
      let {pass, passConfirm, code} = this;
      this.loading = true;

      updateForgottenPassword({pass, passConfirm, code})
        .then(async res => {
          if (!res.ok) {
            return this.$buefy.toast.open({
              message: 'Password Not Updated',
              type: 'is-danger'
            })
          }

          this.$buefy.toast.open({
            message: 'Password Updated!',
            type: 'is-success'
          });

          let user = await res.json();

          localStorage.setItem('user', JSON.stringify(user));
          this.$emit('userUpdated');

          await this.$router.push('/');
        })
        .catch(err => this.$buefy.toast.open({message: err.message, type: 'is-danger'}))
    }
  },
  computed: {
    passConfirmFieldType: function () {
      let {pass, passConfirm} = this;

      if (!passConfirm) {
        return undefined;
      }

      if (pass !== passConfirm) {
        return 'is-danger';
      }

      return 'is-success';
    },
    passConfirmMessage: function () {
      let {passConfirmFieldType} = this;

      let messages = {
        'is-danger': 'Passwords Don\'t Match',
        'is-success': 'Match!'
      }

      return messages[passConfirmFieldType];
    }
  }
}
</script>

<style scoped>

</style>